<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Плейлисты</div>
            <a class="title-block__btn btn-add btn-primary btn" :href="route_create_page">Создать</a>
        </div>
    </div>

    <div class="controls">
        <div class="filter-table__input-wrap search-control">
            <input @keyup.enter="onSearch()" @keyup.delete="onDeleteSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
            <button @click="onSearch()" class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                          stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <div class="selects mb-3">
            <v-select class="select"
                      label="Бренд"
                      v-model="brand"
                      :items="brands"
                      @update:modelValue="onChangeBrand"
                      @update:menu="$removeFocus"
                      @click:clear="$removeFocus"
                      @click:control="$removeFocus"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      color="primary"
                      density="compact"
                      clearable>
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>

            <v-select class="select"
                      label="Тип устройства"
                      v-model="deviceType"
                      :items="deviceTypes"
                      @update:modelValue="onChangeDeviceType"
                      @update:menu="$removeFocus"
                      @click:clear="$removeFocus"
                      @click:control="$removeFocus"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      color="primary"
                      density="compact"
                      clearable>
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table">
            <thead>
            <tr>
                <th v-for="(column, index) in thead">
                    <div class="playlists th-inner sortable asc">
                        <span style="width: 95%;">{{ column }}</span>
                        <div class="dropdown">
                            <svg v-if="sortColumns.includes(column)" @click="toggleDropdown(index)"
                                 style="cursor: pointer;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 7.5L10 12.5L15 7.5" stroke="#575F6E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <div class="dropdown-menu" :class="{ 'show': dropdown_visible[index] }">
                                <a class="dropdown-item" href="#" @click.prevent="sortBy('asc', column)">По возрастанию</a>
                                <a class="dropdown-item" href="#" @click.prevent="sortBy('desc', column)">По убыванию</a>
                            </div>
                        </div>
                    </div>
                </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="row in tbody"
                :key="row.id"
                :class="{ 'row-highlight': highlightedRow === row.id }">
                <td>
                    <div v-if="row.tbody.status === 'actual'" class="marker marker_16px bg-green" title="Активен"></div>
                    <div v-if="row.tbody.status === 'past'" class="marker marker_16px bg-red" title="Не активен"></div>
                    <div v-if="row.tbody.status === 'planned'" class="marker marker_16px" title="Запланирован"><img src="/images/IconClock.svg" alt=""></div>
                </td>
                <td>{{ row.tbody.name }}</td>
                <td>{{ row.tbody.brand }}</td>
                <td>{{ row.tbody.device_type }}</td>
                <td>
                    <div class="table-icon-item table-icon-item_sm me-4">
                        <img class="table-icon-item__icon" src="/images/icon_building.svg" alt="">
                        <span>{{ row.tbody.quantity_locations }}</span>
                    </div>
                    <div class="table-icon-item table-icon-item_sm">
                        <img class="table-icon-item__icon" src="/images/icon_count-device.svg" alt="">
                        <span>{{ row.tbody.quantity_devices }}</span>
                    </div>
                </td>

                <td>
                    <div class="table-icon-item table-icon-item_sm me-4">
                        <img class="table-icon-item__icon" src="/images/IconPhoto.svg" alt="">
                        <span>{{ row.tbody.quantity_content }}</span>
                    </div>
                </td>

                <td>{{ row.tbody.created }}</td>
                <td>{{ row.tbody.user }}</td>

                <td>
                    <div class="table-actions">
                        <a :href="route_update_page + row.id" class="table-action table-action_edit" title="Редактировать"></a>
                        <button @click="markForDelete(row.id)" class="table-action table-action_delete" title="Удалить"></button>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <Transition name="fade">
        <ConfirmModal v-if="showRemoveModal"
            :title="`Вы уверены, что хотите удалить плейлист ${playlistToDelete.tbody.name}`"
            :confirmText="'Ок'"
            :confirmMethod="deletePlaylist"
            :cancelText="'Отмена'"
            @closeModal="hideConfirmModal(state)"/>
    </Transition>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>

import { withPopper } from '../../../utilites.js';
import Playlist from '../../../models/Playlist'
import ChangePage from '../../../helpers/ChangePage'
import PaginationElement from '../../../elements/PaginationElement.vue'
import ConfirmModal from '../../../modals/ConfirmModal.vue';

export default {
    name: 'PlaylistComponent',
    components: { PaginationElement, ConfirmModal },
    props: {
        route_create_page: String,
        route_update_page: String,
        route_list: String,
        route_delete: String,
        route_get: String,
        route_brands_list: String,
        route_get_names_devices_types: String,
        current_page: {
            type: Number,
            default: 1
        },
        domain: String
    },
    data: function () {
        return {
            brand: null,
            brands: [],
            selected_brand : null,
            selected_device_type: null,
            playlist: new Playlist({
                route_list: this.route_list,
                route_delete: this.route_delete
            }),
            search: '',
            thead: [
                'Статус',
                'Название',
                'Бренд',
                'Тип устройства',
                'Количество аптек / устройств',
                'Количество контента',
                'Дата создания',
                'Пользователь',
                'Действия'
            ],
            tbody: [],

            columnMap: {
                'Дата создания': 'playlists.created_at',
            },

            sortColumns: [
                'Дата создания'
            ],
            dropdown_visible: Array(9).fill(false),
            current_sort_direction: '',
            current_sort_column: '',

            deviceType: null,
            deviceTypes: [],
            count: 1,
            limit: 30,
            page: 1,
            highlightedRow: null,
            showRemoveModal: false
        };
    },
    computed: {
        dataLoaded() {
            if (this.brands.length && this.deviceTypes.length) return true;
            else return false;
        },
        playlistToDelete() {
            return this.tbody.find(row => row.id === this.highlightedRow);
        }
    },
    methods: {
        withPopper,
        sortBy(direction, column) {
            this.current_sort_direction = direction;
            this.current_sort_column = this.columnMap[column];
            this.loadTable();
        },
        toggleDropdown: function (index) {
            setTimeout(() => {
                this.dropdown_visible = this.dropdown_visible.map((visible, i) => (i === index ? !visible : false));
            }, 1)
        },
        closeDropdown(event) {
            let clickOutside = event.target.className !== 'dropdown-item';
            let dropDownOpened = document.querySelector('.show') !== null;
            if (dropDownOpened && clickOutside) {
                this.dropdown_visible = this.dropdown_visible.map(() => false);
            }
        },
        markForDelete(id) {
            this.highlightedRow = id;
            this.showConfirmModal();
        },
        deletePlaylist() {
            this.playlist.delete(this.highlightedRow).then(() => {
                this.highlightedRow = null;
                this.loadTable();
            });
            this.hideConfirmModal();
        },
        showConfirmModal() {
            this.showRemoveModal = true;
        },
        hideConfirmModal(state) {
            this.showRemoveModal = state;
            this.highlightedRow = null;
        },
        loadTable: async function () {
            let response = await this.playlist.loadTable(
                this.page,
                this.limit,
                this.search,
                this.selected_device_type,
                this.selected_brand,
                this.current_sort_column,
                this.current_sort_direction,
            );
            this.tbody = response.tbody;
            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        getBrands: async function () {
            let data = await axios.get(this.route_brands_list);
            this.brands = data.data.items;
        },
        getDevicesTypesName: async function () {
            let data = await axios.get(this.route_get_names_devices_types);
            let deviceTypesData = data.data;

            for (const key in deviceTypesData) {
                this.deviceTypes[key] = {
                    id: deviceTypesData[key].id,
                    name: deviceTypesData[key].name
                }
            }
        },
        onChangeBrand: async function (brand_id) {
            this.selected_brand = brand_id;
            localStorage.setItem('playlist_selected_brand', brand_id);
            this.loadTable();
        },
        onChangeDeviceType: async function (type_id) {
            this.selected_device_type = type_id;
            localStorage.setItem('playlist_selected_device_type', type_id);
            this.loadTable();
        },
        onSearch: async function() {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.search.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
        getFilterState() {
            this.brand = this.brands.find(brand => brand.id === Number(JSON.parse(localStorage.getItem('playlist_selected_brand')))) ?? null;
            this.selected_brand = this.brand?.id;

            this.deviceType = this.deviceTypes.find(deviceType => deviceType.id === JSON.parse(localStorage.getItem('playlist_selected_device_type'))) ?? null;
            this.selected_device_type = this.deviceType?.id;
        }
    },
    watch: {
        brand(val) {
            if (!val) {
                localStorage.removeItem('playlist_selected_brand');
            }
        },
        deviceType(val) {
            if (!val) {
                localStorage.removeItem('playlist_selected_device_type');
            }
        },
        dataLoaded(val) {
            if (val) {
                this.getFilterState();
                this.loadTable();
            }
        }
    },
    mounted() {
        this.loadTable();
        this.getBrands();
        this.getDevicesTypesName();
    }
};
</script>

<style scoped lang="scss">
.playlists {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
}
.controls {
    display: flex;
    gap: 16px;
}
.selects {
    display: flex;
    gap: 12px;
}
.select {
    width: 250px;
}
</style>
